<h1 mat-dialog-title>Enviar Firma?</h1>
<div class="containerModal">
  <form [formGroup]="firma" mat-dialog-content>
    <mat-radio-group formControlName="tipo">
      <mat-radio-button value="1" (change)="siguiente($event.value)">Si</mat-radio-button>
      <mat-radio-button value="0" (change)="siguiente($event.value)">No</mat-radio-button>
    </mat-radio-group>
  </form>
</div>
